<div
  [ngClass]="{
    'inbox-desktop-view': (isMobile$ | async) === false,
    'inbox-mobile-view': (isMobile$ | async) === true
  }"
>
  <router-outlet></router-outlet>
</div>
